/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
import React, { useEffect, useState } from 'react';
import { Typography, Modal, Button, Row, Col, message, Table, Avatar, Divider, Popconfirm, Input } from 'antd';
import moment from 'moment';
import { DataService } from '../../../config/dataService/dataService';
import { ImagePreview } from '../../common';
import {
  API_ENDPOINT,
  BLOOD_GROUPS,
  EMPLOYEE_TYPE,
  GENDERS,
  UPDATE_REQUEST_STATUS_JSON,
} from '../../../config/config';
import { TableWrapper } from '../../../container/styled';

const { Text, Title } = Typography;

const FIELD_LABELS = {
  name: 'Name',
  father_name: "Father's Name",
  cnic: 'CNIC',
  contact: 'Contact',
  date_of_birth: 'Date of Birth',
  blood_group_id: 'Blood Group',
  is_biometric_verified: 'Nadra Verified',
  is_police_verified: 'Police Verified',
  // profile_picture: 'Profile Picture',
  gender_id: 'Gender',
  designation_id: 'Designation',
  // desig_title: 'Designation',
  emp_type: 'Employee Type',
};

const getLabelByField = (field, value, { rest = {}, isForNew = false, isForTitle = false }) => {
  const mappings = {
    gender_id: GENDERS,
    // designation_id: SECURITY_COMPANY_DESIGNATION2S,
    blood_group_id: BLOOD_GROUPS,
    emp_type: EMPLOYEE_TYPE,
  };

  if (mappings[field]) {
    return mappings[field].find((item) => item.id === Number(value))?.label || 'N/A';
  }

  if (field === 'date_of_birth') {
    return moment(value).format('D MMM YYYY');
  }

  if (['is_biometric_verified', 'is_police_verified'].includes(field)) {
    return Number(value) === 1 ? 'Verified' : 'Not Verified';
  }

  if (field === 'designation_id' && rest) {
    if (isForTitle) return value;
    if (isForNew) {
      return rest.new_desig_title;
    }
    return rest.old_desig_title;
  }

  return value || 'N/A';
};

const DetailsDialog = ({ showDialog, isEdit = false, setReload, editId }) => {
  const [busy, setBusy] = useState(false);
  const [remarks, setRemarks] = useState('');
  const [data, setData] = useState({ request: {}, changes: [] });
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const fetchDetails = async (id) => {
    setBusy(true);
    try {
      const response = await DataService.post('/update-reqs/get-by-id', { id });
      if (response.data.status) {
        setData(response.data.data);
      } else {
        message.error(response.data.message || response.message);
      }
    } catch (error) {
      console.error('Error fetching details:', error);
      message.error(error.message);
    } finally {
      setBusy(false);
    }
  };

  const handleAction = async (action) => {
    if (action === 'reject' && remarks.length < 3) {
      message.error('Please enter your remarks before rejection');
      return;
    }

    setBusy(true);
    try {
      const endpoint = action === 'approve' ? '/update-reqs/approve-request' : '/update-reqs/reject-request';
      const payload = { id: editId, ...(action === 'reject' && { remarks }) };
      const response = await DataService.post(endpoint, payload);

      if (response.data.status) {
        message.success(response.data.message, () => {
          setReload(true);
          showDialog(false);
        });
      } else {
        message.error(response.data.message);
      }
    } catch (error) {
      console.error(`Error ${action}ing request:`, error);
      message.error(`Failed to ${action} the request.`);
    } finally {
      setBusy(false);
    }
  };

  useEffect(() => {
    if (isEdit && editId) {
      fetchDetails(editId);
    }
  }, [isEdit, editId]);

  const { request, changes } = data;
  const sortedChanges = [...changes].sort((a, b) => (a.field_name === 'profile_picture' ? -1 : b.field_name === 'profile_picture' ? 1 : 0));

  const columns = [
    {
      title: 'Field',
      dataIndex: 'field_name',
      key: 'field_name',
      render: (field) => <Text>{FIELD_LABELS[field] || field}</Text>,
    },
    {
      title: 'Old Value',
      dataIndex: 'old_value',
      key: 'old_value',
      render: (value, record) => (
        <div className="flex justify-center items-center">
          {record.field_name === 'profile_picture' ? (
            <Avatar
              src={value ? `${API_ENDPOINT}/${value}` : require('../../../static/img/avatar/profileImage.png')}
              size={50}
              onClick={() => {
                setSelectedImage(`${API_ENDPOINT}/${value}`);
                setIsImageModalOpen(true);
              }}
            />
          ) : (
            <Text style={{ color: 'green' }}>{getLabelByField(record.field_name, value, { rest: record, isForNew: false })}</Text>
          )}
        </div>
      ),
    },
    {
      title: 'New Value',
      dataIndex: 'new_value',
      key: 'new_value',
      render: (value, record) => (
        <div className="flex justify-center items-center">
          {record.field_name === 'profile_picture' ? (
            <Avatar
              src={value ? `${API_ENDPOINT}/${value}` : require('../../../static/img/avatar/profileImage.png')}
              size={50}
              onClick={() => {
                setSelectedImage(`${API_ENDPOINT}/${value}`);
                setIsImageModalOpen(true);
              }}
            />
          ) : (
            <Text style={{ color: 'blue' }}>{getLabelByField(record.field_name, value, { rest: record, isForNew: true })}</Text>
          )}
        </div>
      ),
    },
  ];

  return (
    <Modal
      open
      title="Update Request Details"
      footer={null}
      centered
      width="70%"
      confirmLoading={busy}
      onCancel={() => showDialog(false)}
      destroyOnClose
    >
      <Row gutter={[16, 16]}>
        <Col span={8} className='flex justify-center items-center border-r-2 border-red-200'>
          <Avatar
            src={request.profile_picture ? `${API_ENDPOINT}/${request.profile_picture}` : require('../../../static/img/avatar/profileImage.png')}
            size={150}
            onClick={() => {
              setSelectedImage(`${API_ENDPOINT}/${request.profile_picture}`);
              setIsImageModalOpen(true);
            }}
          />
        </Col>
        <Col span={16}>
          {Object.entries(FIELD_LABELS).map(([key, label]) =>
            request[key] && (
              <div key={key} className='mb-1'>
                <Text strong>{label}:</Text> <Text>{getLabelByField(key, request[key], { rest: {}, isForNew: false, isForTitle: true })}</Text>
              </div>
            )
          )}
        </Col>
      </Row>
      <Divider className='bg-red-200' />

      <div className="mt-2">
        <Text strong>Fields to be Updated</Text>
        <TableWrapper>
          <Table
            rowKey="field_name"
            dataSource={sortedChanges}
            columns={columns}
            bordered
            size="middle"
            pagination={false}
            scroll={{ y: 'calc(100vh - 600px)' }}
          />
        </TableWrapper>
      </div>

      <div className='mt-2'>
        <Text strong>Remarks</Text>
        <Input
          value={remarks}
          disabled={busy}
          onChange={(e) => setRemarks(e.target.value)}
          placeholder='Enter Your Remarks'
        />
      </div>

      <div className="flex justify-end mt-4">
        <Button type="default" onClick={() => showDialog(false)} disabled={busy}>Close</Button>
        &nbsp;
        {Number(request.status) === UPDATE_REQUEST_STATUS_JSON.PENDING && (
          <>
            <Popconfirm
              title="Please confirm your action"
              onConfirm={() => handleAction('reject')}
              okText="Yes, Confirm"
              cancelText="No, Cancel"
            >
              <Button type="danger" loading={busy} disabled={busy}>Reject</Button>
            </Popconfirm>
            &nbsp;
            <Popconfirm
              title="Please confirm your action"
              onConfirm={() => handleAction('approve')}
              okText="Yes, Confirm"
              cancelText="No, Cancel"
            >
              <Button type="primary" loading={busy} disabled={busy}>Approve</Button>
            </Popconfirm>
          </>
        )}
      </div>

      <ImagePreview
        visible={isImageModalOpen}
        imageSrc={selectedImage}
        onClose={() => setIsImageModalOpen(false)}
      />
    </Modal>
  );
};

export default DetailsDialog;
